import { ReduxState } from 'src/store/types';

export const isConnectingSelector = (state: ReduxState) =>
  state.connections.pendingConnectToStardog;
